// extracted by css-extract-rspack-plugin
export default {"Item":"Selector-module__Item__NDNbD"};